import React, { FC, memo, ReactNode } from 'react'

import { SharedFacetItemProps } from '@Components/Facet/Display/Items/ItemProps'
import { Checkbox } from '@Components/FormElements/UI/Checkbox'

import styles from './Checkbox.module.scss'

interface CheckboxItemProps extends SharedFacetItemProps {
  checked: boolean
  count: number
  disabled?: boolean
  onChange?: () => void
  text: ReactNode
}

export const CheckboxItem: FC<CheckboxItemProps> = memo(({
  checked,
  count,
  disabled,
  id,
  onChange,
  text,
}) => (
  <div className={styles.facetDisplayRoot}>
    <Checkbox
      checked={checked}
      disabled={disabled}
      id={id}
      label={`${text}`}
      name={id}
      onChange={onChange}
      secondaryLabel={`(${count})`}
    >
      {text}
    </Checkbox>
  </div>
), (prev, next) => prev.checked === next.checked && prev.count === next.count && prev.disabled === next.disabled)
